// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mail-form[data-v-5abb6354] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n.mail-form .form[data-v-5abb6354] {\n  width: 60%;\n  display: inline-block;\n}\n.mail-form .btnhandles[data-v-5abb6354] {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n.mail-form .btnhandles button[data-v-5abb6354] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
